import React from "react";
import { BaseUbuoy1} from "../..";

const Index = () => {
  return (
    <div>
      <BaseUbuoy1/>
    </div>
  );
};

export default Index;
